import { formatDate } from 'core/utils/date'

import { type Location } from '../domain/Location'

export function formatLocation(location?: Location) {
  if (!location) return

  const timestamp = formatDate(new Date(location.timestamp), 'MMM d - k:mm')

  return `${location.city}, ${location.state} ⦁ ${timestamp}`
}

export function formatHours(date: Date) {
  return formatDate(date, 'kk:mm')
}

export function formatLastLocation(locations?: Location[]) {
  if (!locations?.length) {
    return 'No updates yet'
  }

  const lastLocation = locations[0]
  const timestamp = formatDate(new Date(lastLocation.timestamp), 'MMM d, k:mm')

  return `Last Update: ${lastLocation.city}, ${lastLocation.state} at ${timestamp}`
}

export function formatLocationDate({ timestamp }: Location) {
  return formatDate(new Date(timestamp), 'MMM d, k:mm')
}

export function formatLocationSource({ source }: Location) {
  switch (source) {
    case 'project-44':
      return 'P44'
    case 'trucker-tools':
      return 'Trucker Tools'
    case 'edi-platform-core':
      return 'EDI'
    case 'loads-app':
    case 'quick-track':
      return 'Mobile'
    case 'shipper-guide-user':
      return 'Manual'
  }
}
